import React, { useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import { history } from "../../../modules/history.js";
import { modalType } from "../../../modules/constants";
import { Button } from "../../ui-library/AuthControls/Button";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";

const Subtitle = styled.p`
  font-weight: 600;
  color: ${(props) => props.theme?.nero};
  opacity: 0.63;
`;

const AccountConfirmation = (props) => {
  const { isTokenValid, closeModalGoHome, accountValidated, setOpenAuthModal } =
    props;

  const { t } = useTranslation();

  const [subtitle, setSubtitle] = useState("");
  const [buttonText, setButtonText] = useState("");

  const goHome = (event) => {
    event.preventDefault();
    if (buttonText === t("appText.home")) {
      closeModalGoHome();
    } else {
      history.push("/home");
      setOpenAuthModal(modalType.login, t("appText.login"));
    }
  };

  useEffect(() => {
    if (accountValidated === false) {
      setSubtitle(t("appText.auth.linkExpired"));
      setButtonText(t("appText.home"));
    } else {
      setSubtitle(t("appText.auth.account.confirmed"));
      setButtonText(t("appText.login"));
    }
  }, [accountValidated, isTokenValid, t]);

  return !(isTokenValid?.length <= 0) ? (
    <form
      onSubmit={goHome}
      className="auth-form"
      data-testid="account-confirmation-view"
    >
      <Subtitle>{subtitle}</Subtitle>
      <Button text={buttonText} />
    </form>
  ) : (
    <LoadingSpinner />
  );
};

export default withTheme(AccountConfirmation);
